import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=7450d6cf"
import script from "./RadioButton.vue?vue&type=script&lang=js"
export * from "./RadioButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7450d6cf')) {
      api.createRecord('7450d6cf', component.options)
    } else {
      api.reload('7450d6cf', component.options)
    }
    module.hot.accept("./RadioButton.vue?vue&type=template&id=7450d6cf", function () {
      api.rerender('7450d6cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/RadioButton.vue"
export default component.exports